/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface EmrClusterDefinitionCapacityReservationOptions { 
    /**
     * Indicates whether to use unused Capacity Reservations for fulfilling On-Demand capacity                
     */
    usageStrategy?: string;
    /**
     * Indicates the instance's Capacity Reservation preferences                
     */
    capacityReservationPreference?: string;
    /**
     * The ARN of the Capacity Reservation resource group in which to run the instance                
     */
    capacityReservationResourceGroupArn?: string;
}
